import script from "./DVSStep3Material.vue?vue&type=script&setup=true&lang=js"
export * from "./DVSStep3Material.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__